import { createUseStyles } from 'react-jss';

export default createUseStyles({
  plotWrapper: {
    height: '100%',
    margin: '20px',
    '@media(max-width: 900px)': {
      margin: '20px 0px 20px 0px',
    }
  },

  plotWrapperTitle: {
    color: '#102131',
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 30,
    minHeight: '22px',
    '@media(max-width: 900px)': {
      marginBottom: 20,
      justifyContent: 'center',
    }
  },

  plotCard: {
    borderRadius: '10px',
    backgroundColor: 'white',
    paddingTop: '16px',
    height: 'calc(100% - 60px)',
    overflow: 'hidden',
  },

  tooltip: {
    marginLeft: '12px',
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    fontWeight: '800',
    textAlign: 'center',
    fontSize: '14px',
  },
});
